/* THIS FILE IS GENERATED. DO NOT EDIT */

import { PropsFromComponent } from '@/types/component';
import { withDebugMetadata } from '@/utils/withDebugMetadata';
import { withLabradorInstanceof } from '@/utils/withInstanceofProp';
import { LabradorSlider as ResolvedLabradorSlider } from 'base/components/labrador/Slider';

export const LabradorSlider: typeof ResolvedLabradorSlider = withLabradorInstanceof((props) => {
    return <ResolvedLabradorSlider {...props} {...withDebugMetadata({type: props.type, meta: props.meta})} />;
});

export type LabradorSliderProps = PropsFromComponent<typeof LabradorSlider>;
